import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Form, InputNumber } from 'antd';

export function Less(): JSX.Element {
	return (
		<Col span={12}>
			<Form.Item name="max_overall_score" label={I18n.get('Maximum')} labelCol={{ span: 24 }}>
				<InputNumber controls={false} placeholder={I18n.get('Maximum')} />
			</Form.Item>
		</Col>
	);
}
